import {toast} from 'react-toastify';
import {deleteOneSpecialFilter} from '../../../api/specialsFilters.api';
import {toast_loader} from '../../../assets/utils/toast';
import {DeleteModal} from '../../../components/modals/DeleteModal';
import {useAppDispatch, useAppSelector} from '../../../hooks/useReduxHook';
import {useResetFilters} from '../../../hooks/useResetFilters';
import {resetFilteredSelectedItemAction} from '../../../redux/filtersSelected';
import {deleteModalAction} from '../../../redux/modals';

export const DeleteSpecialFilter = () => {
  const dispatch = useAppDispatch();
  const specialFilterSelected = useAppSelector(
    (state) => state.filtersSelected.specialFilter
  );

  const {resetFilters} = useResetFilters();

  const handleDeleteFilter = async () => {
    const loader = toast.loading('Veuillez patienter...');
    try {
      await deleteOneSpecialFilter(specialFilterSelected?._id);
      resetFilters('specialsFilters');
      dispatch(resetFilteredSelectedItemAction('specialFilter'));
      toast_loader(loader, 'Filtre supprimé avec succès', 'success');
      dispatch(deleteModalAction(false));
    } catch (err) {
      toast_loader(loader, 'Une erreur est survenue', 'error');
    }
  };

  return (
    <DeleteModal
      onDelete={handleDeleteFilter}
      text={`le filtre spécial "${specialFilterSelected?.label}"`}
    />
  );
};
